import { useState } from 'react';
import { Box, Button, FormControlLabel, Switch } from '@mui/material';

import DebugFlowSelector from './DebugFlowSelector';
import { useStyles } from './styles';

interface IDebugOverlayProps {
  startFlow: (flowId: string) => void;
  stopPlayer: () => void;
  generateGreetingsAudio: () => void;
  fetchScripts: () => void;
  fetchParticipantProgress: () => void;
  resetProgress: () => void;
  clearPrerenderedAudio: () => void;
  simulateRegionChange: (regionName: string) => void;
}

const DebugOverlay = ({
  startFlow,
  stopPlayer,
  generateGreetingsAudio,
  fetchScripts,
  fetchParticipantProgress,
  resetProgress,
  clearPrerenderedAudio,
  simulateRegionChange,
}: IDebugOverlayProps) => {
  const classes = useStyles();
  const [simulateRegionMode, setSimulateRegionMode] = useState(false);

  return (
    <Box sx={classes.debugOverlay}>
      <DebugFlowSelector
        onStartFlow={(flowId) => {
          stopPlayer();
          resetProgress();
          startFlow(flowId);
        }}
        simulateMode={simulateRegionMode}
        onSimulateRegionChange={simulateRegionChange}
      />
      <FormControlLabel
        control={
          <Switch
            checked={simulateRegionMode}
            onChange={() => setSimulateRegionMode((v) => !v)}
            size="small"
          />
        }
        label="Simulate region change"
        sx={{ color: '#fff', mt: 1, ml: 1 }}
      />
      <Box sx={{ mt: 3 }}>
        <Button
          sx={classes.debugButton}
          onClick={() => generateGreetingsAudio()}
        >
          Greetings test
        </Button>
        <Button sx={classes.debugButton} onClick={() => fetchScripts()}>
          Fetch scripts data
        </Button>
        <Button
          sx={classes.debugButton}
          onClick={() => fetchParticipantProgress()}
        >
          Fetch progress data
        </Button>
        <Button sx={classes.debugButton} onClick={() => resetProgress()}>
          Reset progress data
        </Button>
        <Button
          sx={classes.debugButton}
          onClick={() => clearPrerenderedAudio()}
        >
          Clear prerendered audio
        </Button>
      </Box>
    </Box>
  );
};

export default DebugOverlay;
